import { z } from 'zod';
import { ESTADOS } from '../dominio.js';
import { estado, uuid } from './comunes.js';
/**
 * Bandeja de aprobación y transiciones de estado.
 *
 * La transición NO se implementa en la aplicación: se delega a
 * `fn_transicionar_estado()` en PostgreSQL, que valida el rol, la transición y
 * el motivo, y escribe el asiento de auditoría en la misma transacción.
 */
export const TIPOS_DOCUMENTO = [
    'REQUERIMIENTO', 'ORDEN', 'SELECCION_PROVEEDOR',
    'EVALUACION_PROVEEDOR', 'APROBACION_PAGO',
];
/** Nombre legible de cada formato, con su código del SIG. */
export const ETIQUETA_TIPO = {
    REQUERIMIENTO: 'Requerimiento',
    ORDEN: 'Orden',
    SELECCION_PROVEEDOR: 'Ficha de selección',
    EVALUACION_PROVEEDOR: 'Ficha de evaluación',
    APROBACION_PAGO: 'Aprobación de pago',
};
export const documentoPendiente = z.object({
    id: uuid,
    numero: z.string(),
    tipo: z.enum(TIPOS_DOCUMENTO),
    subtipo: z.string(),
    estado,
    fechaEmision: z.string(),
    empresa: z.string(),
    obra: z.string().nullable(),
    area: z.string().nullable(),
    emitidoPor: z.string().nullable(),
    diasEnEspera: z.number().int(),
    /** Solo lo traen las órdenes; en los demás formatos va nulo. */
    proveedor: z.string().nullable(),
    moneda: z.string().nullable(),
    total: z.number().nullable(),
});
export const asientoHistorial = z.object({
    id: z.number().int(),
    estadoAnterior: z.enum(ESTADOS).nullable(),
    estadoNuevo: z.enum(ESTADOS),
    motivo: z.string().nullable(),
    fecha: z.iso.datetime(),
    usuario: z.string(),
    cargo: z.string().nullable(),
});
//# sourceMappingURL=validacion.js.map